var pipTemplate = require('@/modules/components/pip.handlebars')
import ChevronUpIcon from '@/assets/media/icons/chevron-up.svg'
import CloseIcon from '@/assets/media/icons/close.svg'
import PauseIcon from '@/assets/media/icons/pause.svg'
import PlayIcon from '@/assets/media/icons/play-circle.svg'
import UnMuteIcon from '@/assets/media/icons/muted.svg'
import MuteIcon from '@/assets/media/icons/volume.svg'
import { SHORT_VIDEO_API } from '@/configs/api'
import { SHORT_VIDEO_TRACKING_TYPE } from '@/configs/constants'
import { TIMEOUT_TRACKING } from '@/configs/settings'
import GlobalSettings from '@/core/global-settings'
import httpResources from '@/libs/axios'
import Cookies from 'js-cookie'
import { getContextValueByKey, updateAppContext } from '~/store/app-context'
const helper = require('@/helpers/index.js')

class PiPVideo extends HTMLElement {
    static get observedAttributes() {
        return ['key', 'playlist-id', 'video-id', 'pip-style']
    }
    constructor() {
        super()
        this.attachShadow({ mode: 'open' })
        this.httpInstance = GlobalSettings.httpInstance || httpResources
        this.baseTrackingUrl = process.env.BASE_API // Using default is current tracking system
        this.trackingUrl = SHORT_VIDEO_API.TRACK_INTERACTION // Using default is current tracking system

        this.pipElement = null
        this.videoElement = null
        this.playpauseBtn = null
        this.exitBtn = null
        this.trackingViewTimer = null
        this.playlistType = null
    }

    connectedCallback() {
        if (GlobalSettings.isUseNewTracking) {
            // Using new tracking system
            this.baseTrackingUrl = `${process.env.TRACKING_ENDPOINT}/api`
            this.trackingUrl = SHORT_VIDEO_API.NEW_TRACK_INTERACTION
        }
        this.pauseIcon = PauseIcon
        this.playIcon = PlayIcon
        this.closeIcon = CloseIcon
        this.backIcon = ChevronUpIcon
        this.muteIcon = UnMuteIcon
        this.unMuteIcon = MuteIcon
        this.getDataAttributes()
        this.initial()
    }

    getDataAttributes() {
        this.src = this.getAttribute('src')
        this.playlistType = this.getAttribute('playlist-type')
        this.colorPrimary = this.getAttribute('color-primary') ? this.getAttribute('color-primary') : '#acacac'
        this.size = this.getAttribute('size') ? this.getAttribute('size') : '0% 100%'
        this.playingTime = this.getAttribute('playing-time') ? parseFloat(this.getAttribute('playing-time')) : 0
        this.duration = this.getAttribute('duration') ? parseInt(this.getAttribute('duration')) : 0
        this.durationVideoTime = this.getAttribute('duration-video-time')
            ? this.getAttribute('duration-video-time')
            : helper.formatVideoTime(0)
        this.pipStyle = this.getAttribute('pip-style') || 'bottom: 0px; right: 15px;'
        this.playlistId = this.getAttribute('playlist-id')
        this.videoId = this.getAttribute('video-id')
        this.organizationId = this.getAttribute('organization-id')
        this.currentIndex = this.getAttribute('current') ? parseInt(this.getAttribute('current')) : 0
        this.loop = this.getAttribute('loop') !== null && this.getAttribute('loop') !== 'false' ? true : false
        this.inPip = this.getAttribute('pip') !== null && this.getAttribute('pip') !== 'false' ? true : false
        this.key = this.getAttribute('key') ? parseInt(this.getAttribute('key')) : 0
        this.uuid = this.getAttribute('uuid')
        this.pipStyle = this.parsepipStyle(this.pipStyle)
        updateAppContext('pip', {
            videoId: this.videoId,
            uuid: this.uuid,
            playlistId: this.playlistId,
            currentTime: this.playingTime,
        })
        this.isMuted = this.getAttribute('muted') == 'false' ? false : true
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'key' && newValue && oldValue !== newValue) {
            // Updated pip
            this.getDataAttributes()
            this.updatePiP()
        } else if (
            (name === 'playlist-id' && newValue && oldValue !== newValue) ||
            (name === 'video-id' && newValue && oldValue !== newValue)
        ) {
            this.getDataAttributes()
        } else if (name === 'pip-style' && newValue && oldValue !== newValue) {
            this.pipStyle = newValue
            this.pipStyle = this.parsepipStyle(this.pipStyle)
        }
    }

    parsepipStyle(pipStyleAttr) {
        const pipStyle = {}

        if (!pipStyleAttr) return pipStyle // No attribute provided, return empty object

        try {
            // Parse the attribute string into a style object
            pipStyleAttr.split(';').forEach((style) => {
                const [key, value] = style.split(':').map((s) => s.trim())
                if (key && value) {
                    pipStyle[key] = value
                }
            })
        } catch (error) {
            console.warn('Invalid pip-style format. Falling back to default styles.', error)
        }

        // Set default values if keys are missing
        if (!('top' in pipStyle) && !('bottom' in pipStyle)) {
            pipStyle.bottom = '0px'
        }
        if (!('left' in pipStyle) && !('right' in pipStyle)) {
            pipStyle.right = '15px'
        }

        // Convert the style object into an inline style string
        return Object.entries(pipStyle)
            .map(([key, value]) => `${key}:${value}`)
            .join('; ')
    }

    updatePiP() {
        this.videoElement.setAttribute('src', this.src)
        this.videoElement.load()
        this.videoElement.currentTime = this.playingTime
        this.videoElement.play()
        this.pipElement.style.display = 'flex'
    }

    async initial() {
        const template = document.createElement('template')
        this.pipStyle = this.parsepipStyle(this.pipStyle)
        var context = {
            src: this.src,
            pauseIcon: this.pauseIcon,
            exitIcon: this.closeIcon,
            colorPrimary: this.colorPrimary,
            backIcon: this.backIcon,
            size: this.size,
            playingTime: helper.formatVideoTime(this.playingTime),
            duration: this.duration,
            durationVideoTime: this.durationVideoTime,
            normalMode: this.normalMode,
            inPip: this.inPip,
            muteIcon: this.muteIcon,
            unMuteIcon: this.unMuteIcon,
            pipStyle: this.pipStyle,
        }
        template.innerHTML = `${pipTemplate(context)}`
        await this.shadowRoot.appendChild(template.content.cloneNode(true))
        helper.appendCommonStyling(this.shadowRoot)
        this.registerEvents()
        this.dragElement(this.shadowRoot.querySelector('.lora-pip'))
    }

    updateVideoMuteState() {
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-pip--toggle-sound-img')
        if (!toggleSoundBtn) return
        const isMuted = this.videoElement?.muted
        const isPlaying = !this.videoElement?.paused
        this.sendPiPInfo(isMuted, isPlaying)
        if (isMuted) {
            toggleSoundBtn.src = this.muteIcon
        } else {
            toggleSoundBtn.src = this.unMuteIcon
        }
    }

    sendPiPInfo(isMuted, isPlaying) {
        window.dispatchEvent(
            new CustomEvent('PIP_INFO', {
                detail: {
                    isMuted: isMuted,
                    isPlaying: isPlaying,
                },
                composed: true,
                bubbles: true,
            })
        )
    }

    registerEvents() {
        this.pipElement = this.shadowRoot.querySelector('.lora-pip')
        this.videoElement = this.shadowRoot.querySelector('.lora-pip__video')

        // Mute / Un-mute action
        const toggleSoundBtn = this.shadowRoot.querySelector('.lora-pip--toggle-sound-btn')
        if (toggleSoundBtn) {
            toggleSoundBtn.addEventListener('click', () => {
                this.videoElement.muted = !this.videoElement?.muted
            })
        }

        // Play/pause
        this.playpauseBtn = this.shadowRoot.querySelector(`.lora-pip__play-pause-btn`)
        this.playpauseBtn.onclick = () => {
            if (this.videoElement.paused) {
                this.videoElement.play()
            } else {
                this.videoElement.pause()
            }
        }

        this.videoElement.addEventListener(
            'canplay',
            () => {
                this.videoElement.currentTime = this.playingTime
                this.videoElement.ontimeupdate = () => {
                    this.playingTime = this.videoElement?.currentTime
                    Cookies.set('lora-embed-pip--playing-time', this.playingTime)
                    updateAppContext('pip', { currentTime: this.playingTime })
                }
                this.videoElement.muted = this.isMuted
                this.videoElement
                    .play()
                    .then(() => {
                        // this.videoElement.muted = false
                        updateAppContext('video', {
                            muted: this.videoElement.muted,
                        })
                    })
                    .catch(() => {
                        this.videoElement.muted = true
                        updateAppContext('video', {
                            muted: true,
                        })
                        this.videoElement.play()
                    })
            },
            { once: true }
        )

        // Pause event handle
        this.videoElement.onpause = () => {
            clearTimeout(this.trackingViewTimer)
            this.trackingViewTimer = null
            this.shadowRoot.querySelector(`.lora-pip__pause-img`).src = this.playIcon
            const isMuted = this.videoElement?.muted
            this.sendPiPInfo(isMuted, false)
        }

        // Play event handle
        this.videoElement.onplay = () => {
            if (!this.trackingViewTimer) {
                this.trackingViewTimer = setTimeout(() => {
                    this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.VIEW)
                }, TIMEOUT_TRACKING)
            }
            this.shadowRoot.querySelector(`.lora-pip__pause-img`).src = this.pauseIcon
            const isMuted = this.videoElement?.muted
            this.sendPiPInfo(isMuted, true)
        }

        // Volume change event handle
        this.videoElement.onvolumechange = () => {
            this.updateVideoMuteState()
        }

        this.exitBtn = this.shadowRoot.querySelector('.lora-pip__exit-pip-btn')
        this.exitBtn.onclick = () => {
            this.exitPiP()
            this.removePipStates()
            updateAppContext('pip', {
                videoId: undefined,
                playlistId: undefined,
                uuid: undefined,
                currentTime: 0,
            })
        }

        const backBtn = this.shadowRoot.querySelector('.lora-pip__back')
        backBtn.onclick = () => {
            this.backFullscreenLayout()
            this.removePipStates()
            this.trackingIOT(SHORT_VIDEO_TRACKING_TYPE.CLICK)
        }
    }

    exitPiP() {
        Cookies.remove('lora-embed-pip')
        Cookies.remove('lora-embed-pip--duration')
        Cookies.remove('lora-embed-pip--duration-string')
        Cookies.remove('lora-embed-pip--playlist-id')
        Cookies.remove('lora-embed-pip--video-id')
        Cookies.remove('lora-embed-pip--current')
        Cookies.remove('lora-embed-pip--loop')
        Cookies.remove('lora-embed-pip--organization-id')
        Cookies.remove('lora-embed-pip--playing-time')
        Cookies.remove('lora-embed-pip--audio')
        Cookies.remove('lora-embed-pip--position')
        this.videoElement.pause()
        this.remove()
    }

    removePipStates() {
        let inFsElements = document.querySelectorAll('.in-fs')
        inFsElements.forEach((inFsElement) => {
            let videoEmbed = inFsElement
            if (inFsElement.classList.contains('is-playlist')) {
                videoEmbed = inFsElement.shadowRoot.querySelector(`video-embed[video-id="${this.videoId}"]`)
            }
            if (videoEmbed) {
                videoEmbed.shadowRoot
                    .querySelector('b-short-video')
                    .shadowRoot.querySelector('.lora-short__pip-overlay')
                    .classList.add('lora--hidden')
            }
            inFsElement.classList.remove('in-fs', 'is-playlist')
            inFsElement.removeAttribute('data-pip')
        })
    }

    backFullscreenLayout() {
        const el = document.createElement('b-fullscreen')
        if (this.playlistId) {
            el.setAttribute('playlist-id', this.playlistId)
            el.setAttribute('current-index', this.currentIndex)
            el.setAttribute('loop', this.loop ? 'true' : 'false')
        }
        el.setAttribute('video-id', this.videoId)
        el.setAttribute('pip-style', this.pipStyle)
        const pipState = getContextValueByKey('pip')
        const uuid = this.uuid || pipState.uuid
        el.setAttribute('uuid', uuid)
        updateAppContext('pip', {
            videoId: this.videoId,
        })
        document.body.appendChild(el)
        this.exitPiP()
    }

    async trackingIOT(trackingType) {
        let user = this.httpInstance.getCurrentUser()
        this.playlistId = this.getAttribute('playlist-id')
        this.playlistType = this.getAttribute('playlist-type')
        const details = []
        const detailTracking = {
            shortVideoId: this.videoId,
            type: trackingType,
            count: 1,
            trackedAt: Math.floor(Date.now() / 1000),
            duration: this.duration,
            ctaLink: '',
            countryCode: GlobalSettings.countryCode,
            productId: null,
        }
        details.push(detailTracking)

        const trackingPayload = {
            playlistId: this.playlistId,
            details,
            organizationId: Number(this.organizationId),
            playlistStoryType: Number(this.playlistType),
            device: GlobalSettings.device,
            domain: GlobalSettings.domainTracking,
        }
        if (GlobalSettings.isUseNewTracking) {
            // Using new tracking system
            this.baseTrackingUrl = `${process.env.TRACKING_ENDPOINT}/api`
            this.trackingUrl = SHORT_VIDEO_API.TRACK_IOT
        } else {
            // Using the current tracking system
            if (SHORT_VIDEO_TRACKING_TYPE.VIEW) {
                await this.httpInstance.repositories.shortVideo.trackView(
                    this.videoId,
                    this.playlistId,
                    user.uid,
                    this.videoItem.organizationId
                )
            }
        }
        if (this.httpInstance.repositories && this.videoId) {
            try {
                await this.httpInstance.repositories.shortVideo.trackIOT(
                    this.trackingUrl,
                    this.baseTrackingUrl,
                    trackingPayload
                )
            } catch (e) {
                console.error(e)
            }
        }
    }

    dragElement(elmnt, remove = false) {
        var pos1 = 0,
            pos2 = 0,
            pos3 = 0,
            pos4 = 0,
            elmntWidth = elmnt.offsetWidth,
            elmntHeight = elmnt.offsetHeight
        if (remove) {
            elmnt.onmousedown = () => {}
            elmnt.ontouchstart = () => {}
        } else {
            elmnt.onmousedown = dragMouseDown
            elmnt.ontouchstart = dragMouseDown
        }

        function dragMouseDown(e) {
            if (e.target.className === 'lora-pip__overlay') {
                e.preventDefault()
            }
            if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
                var touch = e.touches || e.changedTouches
                // get the mouse cursor position at startup:
                pos3 = touch.pageX
                pos4 = touch.pageY
                document.ontouchend = closeDragElement
                // call a function whenever the cursor moves:
                document.ontouchmove = elementDrag
            } else if (
                e.type == 'mousedown' ||
                e.type == 'mouseup' ||
                e.type == 'mousemove' ||
                e.type == 'mouseover' ||
                e.type == 'mouseout' ||
                e.type == 'mouseenter' ||
                e.type == 'mouseleave'
            ) {
                e = e || window.event
                // get the mouse cursor position at startup:
                pos3 = e.clientX
                pos4 = e.clientY
                document.onmouseup = closeDragElement
                // call a function whenever the cursor moves:
                document.onmousemove = elementDrag
            }
        }

        function elementDrag(e) {
            if (e.target.className === 'lora-pip__overlay') {
                e.preventDefault()
            }
            if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
                var touch = e.touches || e.changedTouches
                touch = touch.length ? touch[0] : null
                if (!touch) {
                    return
                }

                // calculate the new cursor position:
                pos1 = pos3 - touch.pageX
                pos2 = pos4 - touch.pageY
                pos3 = touch.pageX
                pos4 = touch.pageY

                // set the element's new position:
                let topOffset = elmnt.offsetTop - pos2
                let leftOffset = elmnt.offsetLeft - pos1
                elmnt.style.top = `${topOffset}px`
                elmnt.style.left = `${leftOffset}px`
            } else if (
                e.type == 'mousedown' ||
                e.type == 'mouseup' ||
                e.type == 'mousemove' ||
                e.type == 'mouseover' ||
                e.type == 'mouseout' ||
                e.type == 'mouseenter' ||
                e.type == 'mouseleave'
            ) {
                e = e || window.event
                // calculate the new cursor position:
                pos1 = pos3 - e.clientX
                pos2 = pos4 - e.clientY
                pos3 = e.clientX
                pos4 = e.clientY

                // set the element's new position:
                let topOffset = elmnt.offsetTop - pos2
                let leftOffset = elmnt.offsetLeft - pos1
                elmnt.style.top = `${topOffset}px`
                elmnt.style.left = `${leftOffset}px`
            }
        }

        function closeDragElement() {
            let elmntTop = elmnt.offsetTop
            let elmntLeft = elmnt.offsetLeft
            let screenX = window.innerWidth
            let screenY = window.innerHeight
            let maxLeft = screenX - elmntWidth
            let maxTop = screenY - elmntHeight
            if (elmntLeft < 0) {
                elmntLeft = 0
            } else if (elmntLeft > maxLeft) {
                elmntLeft = maxLeft
            }
            if (elmntTop < 0) {
                elmntTop = 0
            } else if (elmntTop > maxTop) {
                elmntTop = maxTop
            }
            elmnt.style.top = `${elmntTop}px`
            elmnt.style.left = `${elmntLeft}px`
            /* stop moving when mouse button is released:*/
            document.onmouseup = null
            document.onmousemove = null

            document.ontouchend = null
            document.ontouchmove = null
        }
    }
}
window.customElements.define('b-pip', PiPVideo)
